import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input } from '@angular/core';

import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { DsButtonKind, DsButtonVariant } from '@frontend/ui/button';
import { Store } from '@ngrx/store';

import { IBetslipMessages } from '../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import DigitalActions from '../../../../digital/actions';
import { BetslipResultActions } from '../../actions';

@Component({
    selector: 'bs-digital-result-actions',
    templateUrl: './result-actions.component.html',
    styleUrls: ['./result-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultActionsComponent {
    @HostBinding('class.betslip-result-actions') cssClass = true;

    @Input() inColumn = false;
    @Input() isTeaserBet = false;
    @Input() IsMaxStakeNeverAccepted = false;
    @Input() IsMaxStakePreviouslyAccepted = false;

    messages: IBetslipMessages;

    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'mgm-4': 'secondary', 'sports-interaction': 'secondary' };
    readonly buttonThemeVariant: ThemeOptions<DsButtonVariant> = { 'mgm-4': 'outline', 'sports-interaction': 'outline' };

    @HostBinding('class.teaser-bet-result-actions')
    get isTeaserBetResultAction(): boolean {
        return !this.inColumn && this.isTeaserBet;
    }

    constructor(
        private store: Store,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService,
        protected trackingService: TrackingService,
    ) {
        this.messages = messagesProvider.getMessages();
    }

    return(): void {
        if (this.IsMaxStakeNeverAccepted || this.IsMaxStakePreviouslyAccepted) {
            if (this.inColumn) {
                this.maxstakeBackCloseCTA('close cta');
            } else {
                this.maxstakeBackCloseCTA('back cta');
            }
        }
        this.store.dispatch(BetslipResultActions.close());
    }

    close(): void {
        this.store.dispatch(BetslipResultActions.close());
        this.store.dispatch(DigitalActions.closePopup());
        if (this.IsMaxStakeNeverAccepted || this.IsMaxStakePreviouslyAccepted) {
            this.maxstakeBackCloseCTA('close cta');
        }
    }

    private maxstakeBackCloseCTA(cta: string): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betslip',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'overask',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: this.IsMaxStakeNeverAccepted
                ? 'First Time Max Stake Exceeded'
                : 'Max Stake previously accepted',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'betslip',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: cta,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }
}
